import { render, staticRenderFns } from "./recommend.vue?vue&type=template&id=358239d1&scoped=true&"
var script = {}
import style0 from "./recommend.vue?vue&type=style&index=0&id=358239d1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358239d1",
  null
  
)

export default component.exports